module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0078.jpg?v=43d167d6";